// extracted by mini-css-extract-plugin
export default {"jobSettings":"settings_jobSettings__FBi6W","actionIcon":"settings_actionIcon__hQTpy","actionIconDisabled":"settings_actionIconDisabled__3AMCH"};